export default "__VITE_ASSET__D2Vlvs1w__"